import React from "react";
import TextView from "../../TextView";
import { TextContainer } from "./styles";
import CustomLoader from "../../../sharedcomponents/CustomLoader";

export const FoundingAmbassadorsAPI = ({ data, isLoading, error }) => {
  if (isLoading) {
    return (
      <TextContainer
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <CustomLoader />
      </TextContainer>
    );
  }

  if (error) {
    return (
      <TextContainer>
        <TextView variant="largeText">
          Error loading Founding Ambassador terms: {error?.message}
        </TextView>
      </TextContainer>
    );
  }

  const faTermsData = data?.data?.results?.find(
    (item) => item.slug === "fa_terms"
  );

  if (!faTermsData) {
    return (
      <TextContainer>
        <TextView variant="largeText">
          Founding Ambassador terms content not found.
        </TextView>
      </TextContainer>
    );
  }

  return (
    <TextContainer>
      <div
        dangerouslySetInnerHTML={{
          __html: faTermsData.body,
        }}
      />
    </TextContainer>
  );
};
